export default "__VITE_ASSET__CKDSDgXa__"